import { Cookie, LunchDining, RestaurantMenu } from '@mui/icons-material';

export default function MealServingIcon({ name, className = '' }) {
	const key = String(name || '').toLowerCase();
	if (key === 'lunch') {
		return <LunchDining fontSize='small' className={className} aria-hidden='true' />;
	}
	if (key === 'snack') {
		return <Cookie fontSize='small' className={className} aria-hidden='true' />;
	}
	return <RestaurantMenu fontSize='small' className={className} aria-hidden='true' />;
}
